import '../IncrementalityPlaybook.scss';
import { CommonShoppingSections } from './Shopping';
import { IncPlaybookSectionBox } from '../IncrementalityPlaybookShared';

const PAGE_TITLE = 'Discovery';

export const Discovery = () => (
  <div className='inc-playbook-page'>
    <IncPlaybookSectionBox
      content={
        <div className='basic-section'>
          <div className='basic-text'>
            Discovery Ads - help you reach people who are ready to discover and engage with your
            brand.
          </div>
          <br />
          <ul className='basic-list'>
            <li>
              Discovery ads are displayed automatically on YouTube Home and Watch Next feeds,
              Discover, and the Gmail Promotions and Social tabs using a single campaign.
            </li>
            <li>
              You can use Discovery ads in a{' '}
              <a href='https://support.google.com/google-ads/answer/13695777?visit_id=638539003473120418-1525429713&rd=1'>
                Discovery campaign.
              </a>
            </li>
          </ul>
          <br />
          <div className='basic-text'>
            Of note, methods outlined below are the same across google platforms for Search,
            Shopping, Display (DV360) & Discovery.
          </div>
          <br />
        </div>
      }
      pageTitle={PAGE_TITLE}
      title='Overview'
    />
    <CommonShoppingSections pageTitle={PAGE_TITLE} />
  </div>
);
